var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAU9JREFUaEPtWcFRwzAQ3FMc50sJoQNKCB3QAeEDw4tJBdTAizE8kg5SApRAB1ACTyYxOsa/YLClsxwYzOqrPUm3u7akkyCi5ZtiBYfTCOiPQRRyts3OVxIzIxOIYcmIoQJGwnqHU4HeKTUOOCwFsu39bCR63USChx4JcNBGknosRuKfjEQ2wr1zSyimTYBPCozL27nALVMmd+qP38aXjylj7Mbm78UzE7CwSQVqbNFCFvtUWFpozxZ6heLGqkoSXnCFlr3Hug+8bLKLw7YFTcq7B4XOkhZtCGYCdbKogME+FZQWooWMlqnDaSFaiBbaKS1GXCl5lEh0zJfwf/cX+vPH6aADeCPb842MCgQZoAKsjf5icTcvixOBVGWM75voVFtK3VWQeLcQQX/ldfHr6LJK6APjM2uIoQ79w3piChFAC4UY6tBPC3UgrdeQwSjwAV6oCk8FkxSmAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanto);
export default __webpack_public_path__ + "static/media/canto.eb3a02a20639c440459b0a08389ac5e0.svg";
export { ForwardRef as ReactComponent };